import './styles/SectionFooter.css';




export default function SectionFooter() {
  

  return (
		<div className="section-footer">
			<h2>Boost your links today</h2>
			<button>Get Started</button>
		</div>
	);

} 